import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CustomNotificationService } from './custom.notification.service';
import { PermissionService } from './permissions.service';

@Injectable({
  providedIn: 'root',
})
export class AgentConsoleGuard implements CanActivate {
  constructor(
    private readonly permissionService: PermissionService,
    private readonly router: Router,
    private readonly notification: CustomNotificationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const hasAccess = this.permissionService.canAccessAgentConsole();

    if (hasAccess) {
      return true;
    }

    this.notification.show(
      'warning',
      'Sin acceso',
      'No tienes permisos para acceder al Agent Console.',
      'topRight',
    );
    this.router.navigate(['/pages/dashboard'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
